var $def = require('./$.def');
$def($def.G + $def.F, {global: require('./$').g});


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/core.global.js
 ** module id = 270
 ** module chunks = 0
 **/